// Lib
import React from 'react';
import styled from 'styled-components';
import { Flex, Heading } from 'rebass';

// Types
import Candidate from 'types/candidates';
import { UserRoleType } from 'types/global';

// Theme
import colors from 'theme/colors';

// Components
import JobBoardCandidate from './JobBoardCandidate';

const StageWrapper = styled(Flex)<any>`
  border-right: 2px solid ${props => (props.borderLess ? 'transparent' : colors.gray)};
`;

interface JobBoardStageProps {
  title: string;
  userRole: UserRoleType;
  candidates?: Candidate[];
  borderLess?: boolean;
}

const JobBoardStage: React.FC<JobBoardStageProps> = (props): JSX.Element => {
  const { title, userRole, candidates, borderLess } = props;
  return (
    <StageWrapper width="100%" flexDirection="column" alignItems="center" borderLess={borderLess}>
      <Heading fontSize="24px" fontWeight={6} mb={4}>
        {title}
      </Heading>
      <Flex width="100%" flexDirection="column" px={2}>
        {candidates &&
          candidates.map(candidate => (
            <JobBoardCandidate key={candidate.id} {...candidate} userRole={userRole} />
          ))}
      </Flex>
    </StageWrapper>
  );
};

export default JobBoardStage;
